export const appsAppGroupsUsingCatalogs = "/apps/app_groups_using_catalogs";
